module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/icon_novel1.6d203.png";